// src/components/AnimationLogo.tsx
import React, { useEffect, useState } from "react";
import Spinner from "./Spinner";
import { Transition } from "@headlessui/react";
import { useSelector } from "react-redux";
import { Appstore } from "../../../redux";

const AnimationLogo: React.FC = () => {
  const [isShowing, setIsShowing] = useState(false);
  const isLoading = useSelector((state: Appstore) => state.loader.isLoading);

  useEffect(() => {
    setIsShowing(true);
    const intervalId = setInterval(() => {
      setIsShowing((prevVisible) => !prevVisible);
    }, 850);

    return () => clearInterval(intervalId);
  }, []);

  return isLoading ? (
    <div className="w-full min-h-screen fixed top-0 left-0 flex items-center justify-center z-[9999]">
      <div
        className="w-full h-full min-h-screen top-0 left-0 fixed bg-[#2c2c2c] opacity-40"
        style={{ zIndex: -1 }}
      />
      <Transition
        show={isShowing}
        enter="transform transition duration-[1600ms]"
        enterFrom="opacity-100 rotate-[-360deg] scale-50"
        enterTo="opacity-100 rotate-0 scale-80"
        leave="transform transition ease-in-out"
        leaveFrom="opacity-100 rotate-0 scale-100"
        leaveTo="opacity-100 scale-50 duration-[800ms]"
      >
        <div className="w-full h-full flex items-center justify-center relative z-10">
          <Spinner />
        </div>
      </Transition>
    </div>
  ) : null;
};

export default AnimationLogo;
